import React, { useState, useEffect } from 'react';
import Logo from '../components/Logo';

function Landing({ onLogin, onRegister }) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [stats, setStats] = useState({ usuarios: 0, envios: 0, ciudades: 0 });

  useEffect(() => {
    const target = { usuarios: 247, envios: 183, ciudades: 34 };
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;
    let current = { usuarios: 0, envios: 0, ciudades: 0 };
    const timer = setInterval(() => {
      current = {
        usuarios: Math.min(current.usuarios + Math.ceil(target.usuarios / steps), target.usuarios),
        envios: Math.min(current.envios + Math.ceil(target.envios / steps), target.envios),
        ciudades: Math.min(current.ciudades + Math.ceil(target.ciudades / steps), target.ciudades),
      };
      setStats({...current});
      if (current.usuarios >= target.usuarios) clearInterval(timer);
    }, interval);
    return () => clearInterval(timer);
  }, []);

  const GoogleIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );

  return (
    <div style={{backgroundColor: '#0d0f14', fontFamily: "'Poppins', sans-serif", color: 'white', minHeight: '100vh'}}>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />

      {/* Navbar */}
      <nav style={{position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        backgroundColor: 'rgba(13,15,20,0.85)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #1e2028', padding: '14px 24px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Logo />
        <div style={{display: 'flex', gap: '8px'}}>
          <button onClick={onLogin}
            style={{border: '1px solid #2a2d35', color: '#9ca3af', backgroundColor: 'transparent',
              padding: '8px 18px', borderRadius: '12px', fontSize: '13px', cursor: 'pointer'}}>
            Entrar
          </button>
          <button onClick={onRegister}
            style={{backgroundColor: '#f97316', color: 'white', fontWeight: '700',
              padding: '8px 18px', borderRadius: '12px', fontSize: '13px', cursor: 'pointer',
              boxShadow: '0 4px 15px #f9731640'}}>
            Unirme gratis
          </button>
        </div>
      </nav>

      {/* Hero */}
      <div style={{paddingTop: '120px', paddingBottom: '80px', padding: '120px 24px 80px', textAlign: 'center', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '80px', left: '-50px', width: '400px', height: '400px',
          borderRadius: '50%', backgroundColor: '#f97316', opacity: 0.06, filter: 'blur(100px)', pointerEvents: 'none'}} />
        <div style={{position: 'absolute', bottom: '0', right: '-50px', width: '400px', height: '400px',
          borderRadius: '50%', backgroundColor: '#f97316', opacity: 0.04, filter: 'blur(100px)', pointerEvents: 'none'}} />

        <div style={{maxWidth: '560px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '6px',
            backgroundColor: '#f9731615', border: '1px solid #f9731630',
            padding: '6px 16px', borderRadius: '20px', marginBottom: '24px'}}>
            <span style={{fontSize: '14px'}}>🌍</span>
            <p style={{color: '#f97316', fontSize: '12px', fontWeight: '600'}}>El viaje ya existe. El envío, también.</p>
          </div>

          <h1 style={{fontSize: '48px', fontWeight: '900', lineHeight: '1.1', marginBottom: '20px', letterSpacing: '-0.03em'}}>
            Alguien ya viaja<br/>
            <span style={{color: '#f97316'}}>hacia donde necesitas</span>
          </h1>

          <p style={{color: '#6b7280', fontSize: '17px', lineHeight: '1.7', marginBottom: '36px', maxWidth: '440px', margin: '0 auto 36px'}}>
            Conectamos rutas con necesidades. Sin desvíos, sin huella innecesaria. La logística más sostenible es la que ya está en marcha.
          </p>

          {/* Buscador */}
          <div style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '20px', padding: '20px', marginBottom: '20px', textAlign: 'left'}}>
            <p style={{color: '#6b7280', fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '12px'}}>
              🔍 ¿Alguien ya va de camino hacia allí?
            </p>
            <div style={{display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px'}}>
              <input placeholder="¿Desde dónde? — Granada, Sevilla..." value={from} onChange={e => setFrom(e.target.value)}
                style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
                  borderRadius: '12px', padding: '13px 16px', fontSize: '14px', outline: 'none', width: '100%'}}
                className="placeholder-gray-600" />
              <input placeholder="¿Hasta dónde? — Madrid, Barcelona..." value={to} onChange={e => setTo(e.target.value)}
                style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white',
                  borderRadius: '12px', padding: '13px 16px', fontSize: '14px', outline: 'none', width: '100%'}}
                className="placeholder-gray-600" />
            </div>
            <button onClick={onRegister}
              style={{backgroundColor: '#f97316', width: '100%', color: 'white', fontWeight: '700',
                padding: '14px', borderRadius: '12px', fontSize: '14px', cursor: 'pointer',
                boxShadow: '0 4px 20px #f9731640'}}>
              Ver viajeros disponibles →
            </button>
          </div>

          {/* Google */}
          <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px'}}>
            <div style={{flex: 1, height: '1px', backgroundColor: '#2a2d35'}} />
            <span style={{color: '#3a3d45', fontSize: '11px'}}>o únete en segundos</span>
            <div style={{flex: 1, height: '1px', backgroundColor: '#2a2d35'}} />
          </div>
          <button onClick={() => window.location.href = 'https://sendvigo-backend-production.up.railway.app/auth/google'}
            style={{width: '100%', backgroundColor: 'white', color: '#111318', fontWeight: '700',
              padding: '13px', borderRadius: '14px', fontSize: '14px', border: 'none', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
            <GoogleIcon />
            Continuar con Google
          </button>
        </div>
      </div>

      {/* Stats */}
      <div style={{backgroundColor: '#1a1d24', borderTop: '1px solid #2a2d35', borderBottom: '1px solid #2a2d35', padding: '32px 24px'}}>
        <div style={{maxWidth: '480px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', textAlign: 'center'}}>
          {[
            { value: stats.usuarios, label: 'Personas registradas', suffix: '+' },
            { value: stats.envios, label: 'Envíos completados', suffix: '+' },
            { value: stats.ciudades, label: 'Ciudades activas', suffix: '' },
          ].map(s => (
            <div key={s.label}>
              <p style={{color: '#f97316', fontWeight: '900', fontSize: '28px', lineHeight: '1'}}>{s.value}{s.suffix}</p>
              <p style={{color: '#6b7280', fontSize: '11px', marginTop: '4px', lineHeight: '1.4'}}>{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Cómo funciona */}
      <div style={{padding: '72px 24px', backgroundColor: '#0d0f14'}}>
        <div style={{maxWidth: '480px', margin: '0 auto', textAlign: 'center'}}>
          <p style={{color: '#f97316', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px'}}>Cómo funciona</p>
          <h2 style={{color: 'white', fontWeight: '800', fontSize: '28px', marginBottom: '48px', letterSpacing: '-0.02em'}}>Tan fácil como llamar a un amigo</h2>
          <div style={{display: 'flex', flexDirection: 'column', gap: '24px'}}>
            {[
              { step: '01', icon: '📦', title: 'Publica lo que necesitas enviar', desc: 'Cuéntale a la comunidad qué necesitas enviar, a dónde y cuánto puedes contribuir al viaje del que te ayude.' },
              { step: '02', icon: '🚗', title: 'Un viajero se ofrece', desc: 'Alguien que ya viaja en esa dirección ve tu publicación y se ofrece a llevarlo de paso. Sin desvíos, sin emisiones extra.' },
              { step: '03', icon: '💬', title: 'Os coordináis por el chat', desc: 'Acordáis el punto de entrega, el horario y la contribución. Todo en el chat integrado de SenDViGo.' },
              { step: '04', icon: '✅', title: '¡Entregado!', desc: 'Confirmáis la entrega, os valoráis mutuamente y vuestros perfiles crecen. Un kilómetro compartido es uno menos contaminado.' },
            ].map(s => (
              <div key={s.step} style={{display: 'flex', alignItems: 'flex-start', gap: '16px', textAlign: 'left',
                backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '16px', padding: '20px'}}>
                <div style={{flexShrink: 0}}>
                  <div style={{width: '44px', height: '44px', borderRadius: '12px', backgroundColor: '#f9731615',
                    border: '1px solid #f9731625', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px'}}>
                    {s.icon}
                  </div>
                </div>
                <div>
                  <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px'}}>
                    <span style={{color: '#f97316', fontSize: '10px', fontWeight: '800'}}>{s.step}</span>
                    <p style={{color: 'white', fontWeight: '700', fontSize: '14px'}}>{s.title}</p>
                  </div>
                  <p style={{color: '#6b7280', fontSize: '13px', lineHeight: '1.6'}}>{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Seguridad */}
      <div style={{padding: '72px 24px', backgroundColor: '#1a1d24'}}>
        <div style={{maxWidth: '480px', margin: '0 auto', textAlign: 'center'}}>
          <p style={{color: '#f97316', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px'}}>Seguridad</p>
          <h2 style={{color: 'white', fontWeight: '800', fontSize: '28px', marginBottom: '12px', letterSpacing: '-0.02em'}}>Construida sobre la confianza</h2>
          <p style={{color: '#6b7280', fontSize: '14px', marginBottom: '36px', lineHeight: '1.6'}}>Cada persona tiene su historial visible. Nadie puede esconderse detrás del anonimato.</p>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px'}}>
            {[
              { icon: '⭐', title: 'Valoraciones reales', desc: 'Cada envío genera una valoración. El historial es público y no se puede borrar.' },
              { icon: '🛡️', title: 'Perfiles verificados', desc: 'Sistema de verificaciones progresivas para aumentar la confianza.' },
              { icon: '💬', title: 'Chat protegido', desc: 'Solo los participantes del envío tienen acceso al chat.' },
              { icon: '🚨', title: 'Sistema de reportes', desc: 'Cualquier comportamiento inadecuado puede reportarse de forma anónima.' },
            ].map(item => (
              <div key={item.title} style={{backgroundColor: '#111318', border: '1px solid #2a2d35',
                borderRadius: '16px', padding: '18px', textAlign: 'left'}}>
                <span style={{fontSize: '24px', display: 'block', marginBottom: '10px'}}>{item.icon}</span>
                <p style={{color: 'white', fontWeight: '700', fontSize: '13px', marginBottom: '6px'}}>{item.title}</p>
                <p style={{color: '#6b7280', fontSize: '12px', lineHeight: '1.5'}}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Testimonios */}
      <div style={{padding: '72px 24px', backgroundColor: '#0d0f14'}}>
        <div style={{maxWidth: '480px', margin: '0 auto'}}>
          <p style={{color: '#f97316', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '8px', textAlign: 'center'}}>Historias reales</p>
          <h2 style={{color: 'white', fontWeight: '800', fontSize: '28px', marginBottom: '8px', textAlign: 'center', letterSpacing: '-0.02em'}}>Lo que dice la comunidad</h2>
          <p style={{color: '#6b7280', fontSize: '14px', textAlign: 'center', marginBottom: '36px'}}>Personas reales que se han ayudado mutuamente</p>
          <div style={{display: 'flex', flexDirection: 'column', gap: '14px'}}>
            {[
              { ruta: 'Madrid → Granada', desc: '🔑 Llaves de casa', aportacion: '8€', testimonio: '"Me las enviaron por la mañana y en menos de 4 horas las tenía en casa. Me ahorré el cerrajero y el viaje."', stars: 5 },
              { ruta: 'Sevilla → Málaga', desc: '📄 Documento urgente', aportacion: '5€', testimonio: '"Salió a las 9 y estaba firmado antes de comer. Increíble la rapidez y la amabilidad de quien lo llevó."', stars: 5 },
              { ruta: 'Motril → Granada', desc: '💊 Medicación urgente', aportacion: '6€', testimonio: '"En una hora las tenía. No tuve que molestar a nadie ni buscar farmacias. La persona fue un cielo."', stars: 5 },
              { ruta: 'Valencia → Barcelona', desc: '👟 Zapatillas para evento', aportacion: '12€', testimonio: '"Pensé que no llegarían a tiempo. Llegaron en 3 horas. ¡Gracias SenDViGo!"', stars: 5 },
            ].map(t => (
              <div key={t.ruta} style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35', borderRadius: '16px', padding: '18px'}}>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px'}}>
                  <div>
                    <p style={{color: 'white', fontWeight: '700', fontSize: '13px'}}>{t.ruta}</p>
                    <p style={{color: '#6b7280', fontSize: '11px', marginTop: '2px'}}>{t.desc}</p>
                  </div>
                  <span style={{backgroundColor: '#22c55e15', color: '#22c55e', fontSize: '10px', fontWeight: '600', padding: '3px 10px', borderRadius: '20px', flexShrink: 0}}>
                    ✓ Entregado
                  </span>
                </div>
                <div style={{display: 'flex', gap: '2px', marginBottom: '8px'}}>
                  {[1,2,3,4,5].map(i => <span key={i} style={{color: '#f59e0b', fontSize: '12px'}}>★</span>)}
                </div>
                <p style={{color: '#9ca3af', fontSize: '13px', fontStyle: 'italic', lineHeight: '1.6'}}>{t.testimonio}</p>
                <p style={{color: '#f97316', fontSize: '11px', fontWeight: '600', marginTop: '8px'}}>{t.aportacion} de contribución</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Final */}
      <div style={{padding: '80px 24px', textAlign: 'center', background: 'linear-gradient(135deg, #ea580c 0%, #f97316 50%, #fb923c 100%)', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '-60px', right: '-60px', width: '250px', height: '250px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.08)'}} />
        <div style={{position: 'absolute', bottom: '-40px', left: '-40px', width: '200px', height: '200px', borderRadius: '50%', backgroundColor: 'rgba(255,255,255,0.06)'}} />
        <div style={{position: 'relative', zIndex: 1, maxWidth: '400px', margin: '0 auto'}}>
          <p style={{fontSize: '40px', marginBottom: '16px'}}>🌍</p>
          <h2 style={{color: 'white', fontWeight: '900', fontSize: '30px', marginBottom: '12px', letterSpacing: '-0.02em'}}>Únete a la comunidad</h2>
          <p style={{color: 'rgba(255,255,255,0.8)', fontSize: '15px', marginBottom: '32px', lineHeight: '1.6'}}>
            Cada viaje compartido es una decisión por el planeta.
          </p>
          <button onClick={onRegister}
            style={{backgroundColor: 'white', color: '#f97316', fontWeight: '800',
              padding: '16px 40px', borderRadius: '16px', fontSize: '15px', cursor: 'pointer',
              boxShadow: '0 8px 32px rgba(0,0,0,0.2)', marginBottom: '16px', display: 'block', width: '100%'}}>
            Quiero unirme gratis 🚀
          </button>
          <button onClick={() => window.location.href = 'https://sendvigo-backend-production.up.railway.app/auth/google'}
            style={{backgroundColor: 'rgba(255,255,255,0.15)', color: 'white', fontWeight: '700',
              padding: '14px 40px', borderRadius: '16px', fontSize: '14px', cursor: 'pointer',
              border: '1px solid rgba(255,255,255,0.3)', display: 'flex', alignItems: 'center',
              justifyContent: 'center', gap: '8px', width: '100%'}}>
            <GoogleIcon />
            Continuar con Google
          </button>
        </div>
      </div>

      {/* Footer */}
      <div style={{padding: '32px 24px', textAlign: 'center', backgroundColor: '#0d0f14', borderTop: '1px solid #1e2028'}}>
        <Logo />
        <p style={{color: '#f97316', fontSize: '12px', fontStyle: 'italic', marginTop: '8px'}}>Cada kilómetro compartido es uno menos contaminado 🌍</p>
        <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '16px', marginBottom: '12px'}}>
          {['Términos', 'Privacidad', 'Soporte'].map(item => (
            <button key={item} onClick={onLogin}
              style={{color: '#3a3d45', fontSize: '11px', background: 'none', border: 'none', cursor: 'pointer'}}>
              {item}
            </button>
          ))}
        </div>
        <p style={{color: '#2a2d35', fontSize: '11px'}}>© 2026 SenDViGo · Baza, Granada, España · soporte@sendvigo.com</p>
      </div>
    </div>
  );
}

export default Landing;